import React from 'react'
import {
  Avatar,
  Paragraph,
  Media,
  List,
  Link,
  PopupStateful
} from '@cobalt/cobalt-react-components'
import { string, bool } from 'prop-types'
import { PROCEED_TO_TALKDESK, LOGOUT } from '../../constants/ui.labels'
import { ROOT, LOGOUT_PAGE } from '../../constants/links'
import redirectTo from '../../utils/redirect/redirectTo'

const renderAvatar = name => {
  const initials = name
    .trim()
    .split(/\s+/)
    .map(str => str[0])
  const first = initials.shift() || ''
  const last = initials.pop() || ''

  return <Avatar small>{`${first}${last}`}</Avatar>
}

const renderMenu = displayLogoutMenuOnly => (
  <List>
    {!displayLogoutMenuOnly && <ProceedToTalkdeskItem />}
    <LogoutItem />
  </List>
)

const logout = () => redirectTo(LOGOUT_PAGE)

const proceedToTalkdesk = () => redirectTo(ROOT)

const ProceedToTalkdeskItem = () => (
  <List.Item>
    <Link onClick={proceedToTalkdesk}>{PROCEED_TO_TALKDESK}</Link>
  </List.Item>
)

const LogoutItem = () => (
  <List.Item>
    <Link onClick={logout}>{LOGOUT}</Link>
  </List.Item>
)

const NavbarMenu = ({ name, email, displayLogoutMenuOnly }) => {
  const avatar = renderAvatar(name)
  const menu = renderMenu(displayLogoutMenuOnly)
  return (
    <PopupStateful.Wrapper>
      <PopupStateful
        position={PopupStateful.POSITION_RIGHT_BOTTOM}
        target={<Link>{avatar}</Link>}
      >
        <PopupStateful.Header>
          <Media alignVerticalCenter>
            {avatar}
            <Paragraph>
              <strong>{name}</strong>
            </Paragraph>
            <Paragraph microcopy>{email}</Paragraph>
          </Media>
        </PopupStateful.Header>
        <PopupStateful.Content noPadding>{menu}</PopupStateful.Content>
      </PopupStateful>
    </PopupStateful.Wrapper>
  )
}

NavbarMenu.propTypes = {
  name: string.isRequired,
  email: string.isRequired,
  displayLogoutMenuOnly: bool
}

NavbarMenu.defaultProps = {
  displayLogoutMenuOnly: false
}

export default NavbarMenu
